import { createContext, useContext } from 'react';

// Content JSON only knows mediaIds (spec section 40); this context resolves them to records.
export const MediaContext = createContext({});

export function useMedia(mediaId) {
  const media = useContext(MediaContext);
  return mediaId ? media[mediaId] : undefined;
}
